import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Cartonization_ds_get_cartonization_workflowsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { workflow_codes?: string[] }): 
  Promise<{ result: { Id?: string, Description?: string, LookupCode?: string, Name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Cartonization/datasources/ds_get_cartonization_workflows/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { workflow_codes?: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: string, Description?: string, LookupCode?: string, Name?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Cartonization/datasources/ds_get_cartonization_workflows/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { workflow_codes?: string[], $keys: string[] }): 
  Promise<{ result: { Id?: string, Description?: string, LookupCode?: string, Name?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Cartonization/datasources/ds_get_cartonization_workflows/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      workflow_codes?: string[]    }) {
      return false;
    }
}
